import SearchMultiselect from '../SearchMultiselect'
import React, { useCallback, useEffect, useState } from 'react'
import {
  Container,
  Options,
  GenerateNotebook,
  LettersUpDown,
  LetterUp,
  LetterDown,
  Selects,
  KeyBoard,
  Wrapper,
  PaginateWrapper,
} from './styles'
import { FaRegKeyboard } from 'react-icons/fa'
import { TPagination } from '../../hooks/use-pagination'
import Paginate from './Pagination'
import TextDropdown from '../TextDropdown'
import { setState } from '../../types/setState'
import CreateQuestionBookModal from './components/CreateQuestioBookModal'
import { IFiltersParams } from '../../pages/SearchQuestions/components/SearchQuestionsContent/types'

interface IProps {
  pagination: TPagination
  itemsPerPage: number
  setItemsPerPage: setState<number>
  setTracking: setState
  setOrderBy: setState<'new' | 'old'>
  setFontSize(fontSize: number): void

  filtersParams: IFiltersParams
  totalQuestions: number
  mostRecent: boolean

  isLoading: boolean

  setOpenModalShortcuts: setState<boolean>
  setOpenModal: setState<boolean>
  openModal: boolean
}

const QuestionForPage: React.FC<IProps> = (props) => {
  const [font, setFont] = useState(16)

  const increaseFontSize = useCallback(() => {
    setFont((prevFontSize) => prevFontSize + 2)
  }, [])

  const decreaseFontSize = useCallback(() => {
    setFont((prevFontSize) => prevFontSize - 2)
  }, [])

  useEffect(() => {
    props.setFontSize(font)
  }, [font, props])

  return (
    <>
      <Container>
        <div className="mobile">
          <SearchMultiselect selected={[]} label="Mais recentes" options={[]} />
        </div>
        <Options>
          <GenerateNotebook
            disabled={props.isLoading || !props.totalQuestions}
            onClick={() => props.setOpenModal(true)}
          >
            Gerar Caderno
          </GenerateNotebook>

          <PaginateWrapper>
            <Paginate pagination={props.pagination} isLoading={props.isLoading} />
          </PaginateWrapper>
          <Wrapper>
            {props.itemsPerPage === 1 ? (
              <KeyBoard onClick={() => props.setOpenModalShortcuts(true)}>
                <FaRegKeyboard size={27} color="#BABABA" />
              </KeyBoard>
            ) : null}
            <LettersUpDown>
              <LetterUp disabled={font === 28} onClick={() => increaseFontSize()}>
                A+
              </LetterUp>
              <LetterDown disabled={font === 14} onClick={() => decreaseFontSize()}>
                A-
              </LetterDown>
            </LettersUpDown>
            <Selects>
              <TextDropdown
                options={[
                  { label: 1, value: 1 },
                  { label: 5, value: 5 },
                  { label: 10, value: 10 },
                  { label: 15, value: 15 },
                  { label: 20, value: 20 },
                ]}
                value={props.itemsPerPage}
                onChange={(value) => props.setItemsPerPage(value as number)}
                className="text-dropdown"
                customLabel={(option) => `Questões por página: ${option?.value}`}
              />
              <TextDropdown
                options={[
                  { label: 'Mais recentes', value: 'new' },
                  { label: 'Mais antigos', value: 'old' },
                ]}
                defaultValue="new"
                onChange={(value) => props.setOrderBy(value as 'new' | 'old')}
                className="text-dropdown"
              />
            </Selects>
          </Wrapper>
        </Options>
      </Container>

      <CreateQuestionBookModal
        isOpen={props.openModal}
        onClose={() => props.setOpenModal(false)}
        filtersParams={props.filtersParams}
        setTracking={props.setTracking}
        totalQuestions={props.totalQuestions}
        mostRecent={props.mostRecent}
      />
    </>
  )
}

export default QuestionForPage
